// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OrderStatus;
(function (OrderStatus) {
    // этого статуса нет на сервере, завел его для обработки ошибок
    OrderStatus[OrderStatus["UNKNOWN"] = 0] = "UNKNOWN";
    // Obsolete.
    // этого статусе нет на сервере но он используется в TradeEmulator, не смог быстро от него отказаться
    OrderStatus[OrderStatus["REPLACED"] = 20] = "REPLACED";
    // ордер создан в нашей системе, но ожидает подтверждения с STP (при STP торговле);
    OrderStatus[OrderStatus["PENDING_NEW"] = 1] = "PENDING_NEW";
    // условия исполнения ордера были выполнены, ордер ожидает подтверждения о исполнении с ЛП
    OrderStatus[OrderStatus["PENDING_EXECUTION"] = 2] = "PENDING_EXECUTION";
    // запрос на отмену отправлен, ордер ожидает подтверждение отмены
    OrderStatus[OrderStatus["PENDING_CANCEL"] = 3] = "PENDING_CANCEL";
    // запрос на модификацию отправлен, ордер ожидает подтверждения модификации
    OrderStatus[OrderStatus["PENDING_REPLACE"] = 4] = "PENDING_REPLACE";
    // модификация неактивного ордера (раньше была константа CONFIRMED_NEW)
    OrderStatus[OrderStatus["PENDING_REPLACE_NOT_ACTIVE"] = 5] = "PENDING_REPLACE_NOT_ACTIVE";
    // ордер создан в нашей системе (отправлен запрос на LP)
    OrderStatus[OrderStatus["NEW"] = 10] = "NEW";
    // ордер создан нашей системой, но неактивен до выполнения
    // определенных условий. Пример = реверс позиции, открывающий ордер будет иметь статус Accepted
    // пока не исполнится закрывающий ордер
    OrderStatus[OrderStatus["ACCEPTED"] = 11] = "ACCEPTED";
    // ордер частично исполнен
    OrderStatus[OrderStatus["PART_FILLED"] = 30] = "PART_FILLED";
    // ордер полностью исполнен
    OrderStatus[OrderStatus["FILLED"] = 31] = "FILLED";
    // ордер отменен
    OrderStatus[OrderStatus["CANCELED"] = 40] = "CANCELED";
    // ордер отклонен
    OrderStatus[OrderStatus["REFUSED"] = 41] = "REFUSED";
    // ордер создан, но торговая сессия закрыта, ордер находится в состоянии ожидания открытия рынка
    OrderStatus[OrderStatus["WAITING_MARKET"] = 50] = "WAITING_MARKET";
    // #123040
    OrderStatus[OrderStatus["WAITING_CANCELLATION"] = 51] = "WAITING_CANCELLATION";
    // ордер создан локально и будет отправлен на биржу после открытия рынка.
    OrderStatus[OrderStatus["OFF_MARKET"] = 60] = "OFF_MARKET";
    // ордер был деактивирован на бирже, при этом в нашей системе он остался и с ним могут выполнятся действия.
    // Исполнится он сможет только когда биржа его активирует
    OrderStatus[OrderStatus["UNPLACED"] = 70] = "UNPLACED";
    // удаляем ордер из панелей
    OrderStatus[OrderStatus["REMOVED"] = 80] = "REMOVED";
})(OrderStatus || (OrderStatus = {}));
